import React from 'react';

export default class PlugIcon extends React.Component{	
   render() {
	 return (
		<svg className={this.props.className} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
			viewBox="0 0 511.999 511.999" >
		<g>
			<g>
				<path d="M112.012,401.394c-8.003-8.003-18.643-12.41-29.959-12.41c-6.685,0-13.129,1.55-18.938,4.458
					C6.032,312.568,5.834,201.743,63.598,120.673c3.204-4.498,2.156-10.742-2.342-13.947c-4.498-3.205-10.742-2.157-13.947,2.341
					C15.446,153.786-0.9,206.594,0.038,261.781C0.931,314.3,17.421,364.12,47.802,406.413c-12.072,16.56-10.643,39.962,4.292,54.899
					c8.26,8.259,19.109,12.389,29.959,12.389c10.85,0,21.699-4.13,29.959-12.389C128.531,444.792,128.531,417.914,112.012,401.394z
					M97.869,447.169c-8.723,8.721-22.912,8.721-31.633,0c-8.722-8.722-8.722-22.913,0-31.634c4.225-4.225,9.842-6.552,15.816-6.552
					s11.592,2.327,15.816,6.552C106.591,424.257,106.591,438.448,97.869,447.169z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M407.962,451.145c-3.231-4.476-9.481-5.484-13.96-2.249c-28.588,20.657-60.725,34.342-95.519,40.675
					c-8.062,1.468-16.284-0.693-22.557-5.927c-6.228-5.196-9.799-12.83-9.799-20.943v-73.298H267c11.579,0,21-9.42,21-21V351.52
					c33.873-12.93,58-45.756,58-84.116v-47.345c16.116-4.402,28-19.163,28-36.655c0-19.257-14.403-35.204-33-37.661V83.404
					c0-16.542-13.458-30-30-30s-30,13.458-30,30v62h-50v-62c0-16.542-13.458-30-30-30s-30,13.458-30,30v62.339
					c-18.597,2.457-33,18.403-33,37.661c0,17.492,11.884,32.253,28,36.655v47.345c0,38.36,24.127,71.186,58,84.116v16.884
					c0,11.58,9.421,21,21,21h1.127v73.298c0,14.062,6.191,27.292,16.985,36.299c8.615,7.188,19.351,11.023,30.379,11.023
					c2.849,0,5.717-0.256,8.573-0.776c37.752-6.872,72.625-21.723,103.649-44.141C410.19,461.872,411.196,455.621,407.962,451.145z
					M301.001,83.404c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10v62h-20V83.404z M191.001,83.404c0-5.514,4.486-10,10-10
					c5.514,0,10,4.486,10,10v62h-20V83.404z M158.001,183.404c0-9.925,8.075-18,18-18h160c9.925,0,18,8.075,18,18s-8.075,18-18,18
					h-160C166.076,201.404,158.001,193.329,158.001,183.404z M186.001,267.404v-46h140v46c0,38.598-31.402,70-70,70
					C217.403,337.404,186.001,306.002,186.001,267.404z M256.38,369.404c-0.084-0.002-0.167-0.013-0.251-0.013
					c-0.084,0-0.167,0.011-0.251,0.013h-10.875c-0.554,0-1.002-0.449-1.002-1v-11.802c3.927,0.526,7.932,0.802,12,0.802
					s8.073-0.276,12-0.802v11.802c0,0.551-0.448,1-1,1H256.38z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M436.772,424.041c-3.963-3.7-10.138-3.557-13.928,0.274c-0.077,0.078-0.154,0.158-0.227,0.235
					c-3.769,4.038-3.55,10.365,0.487,14.134c1.928,1.799,4.377,2.689,6.821,2.689c2.583,0,5.16-0.995,7.107-2.963
					c0.077-0.078,0.154-0.158,0.227-0.235C441.028,434.137,440.809,427.81,436.772,424.041z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M511.321,238.712c-4.455-61.218-30.842-118.866-74.297-162.323c-42.712-42.715-99.768-68.861-160.657-73.62
					C216.22-1.934,156.359,14.388,107.791,48.724c-4.51,3.188-5.581,9.429-2.393,13.938c3.187,4.509,9.429,5.582,13.938,2.393
					c92.873-65.657,223.369-54.706,303.546,25.476c82.857,82.861,92.876,211.536,23.821,305.96c-3.26,4.458-2.289,10.714,2.169,13.975
					c1.78,1.302,3.847,1.929,5.896,1.929c3.081,0,6.121-1.419,8.08-4.098C498.516,359.523,515.732,299.297,511.321,238.712z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M87.909,77.545c-3.923-3.887-10.255-3.861-14.143,0.063l-0.163,0.166c-3.888,3.922-3.859,10.254,0.063,14.142
					c1.95,1.932,4.495,2.897,7.04,2.897c2.573,0,5.147-0.988,7.103-2.96l0.163-0.166C91.86,87.765,91.831,81.433,87.909,77.545z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M278.548,263.701c-1.792-3.074-5.082-4.964-8.64-4.964h-7.146l13.162-16.626c3.428-4.33,2.696-10.62-1.634-14.047
					c-4.33-3.429-10.62-2.696-14.048,1.633L234.25,262.53c-2.38,3.007-2.831,7.11-1.161,10.562c1.67,3.452,5.167,5.645,9.002,5.645
					h10.66l-12.246,21.622c-2.722,4.806-1.032,10.908,3.772,13.629c1.558,0.882,3.249,1.301,4.92,1.301
					c3.487-0.001,6.872-1.826,8.712-5.074l20.701-36.55C280.364,270.569,280.34,266.775,278.548,263.701z"/>
			</g>
		</g>
	</svg>
		)
	}
}




// WEBPACK FOOTER //
// ./src/icons/plug.js